import React from 'react';
import ReactDOM from 'react-dom';
import useContentful from './hooks/useContentful';
import Loader from './components/Loader';
import ArticleTemplate from './components/Blog/Article';
import { ContentfulArticle } from './components/Blog/Blog';

const reactTarget = 'article-template-react-target';

interface ContentfulQueryArgs {
  content_type: string;
  'fields.slug': string;
  include: number;
  'metadata.tags.sys.id[in]'?: string;
}

const ArticlePage = () => {
  const targetEl = document.getElementById(reactTarget);
  const articleHandle = targetEl?.dataset?.shopifyArticleHandle;

  if (!articleHandle) {
    return null;
  }

  const slug = articleHandle.split('/')[1];
  const queryArgs: ContentfulQueryArgs = {
    content_type: 'article', 
    'fields.slug': slug, 
    include: 10 
  }

  const contentfulTagId = document.getElementById(reactTarget)?.dataset?.contentfulTagId;
  if (contentfulTagId) {
    queryArgs['metadata.tags.sys.id[in]'] = contentfulTagId;
  }

  const { contentfulData, isLoadingContentful } = useContentful(queryArgs);

  if (isLoadingContentful) {
    return <Loader />;
  }

  if (contentfulData && contentfulData?.items.length > 0) {
    const article = contentfulData.items[0] as ContentfulArticle;
    const blogUrl = targetEl?.dataset?.shopifyBlogUrl;
    
    return (
      <ArticleTemplate 
        article={article} 
        blogUrl={blogUrl} 
        contentfulTagId={contentfulTagId}
      />
    );
  }

  return null;
}

ReactDOM.render(<ArticlePage />, document.getElementById(reactTarget));